import secretApiAxios from "../../endpoints/core/secretApiAxios";

export class ConcessionariaService {

  static async findBySigagente(sigagente) {
    return await secretApiAxios
      .get(`concessionarias?filters[sigagente][$eq]=${sigagente}&populate=*`)
      .then(data => data.data?.data?.[0])
      .catch(err => false);
  }

  static async findById(id) {
    return await secretApiAxios
      .get(`concessionarias?filters[id][$eq]=${parseInt(id)}`)
      .then(data => data.data?.data?.[0])
      .catch(err => false);
  }

  static async findByMunicipio(municipio, uf) {
    if(!municipio || !uf) {
      return false;
    }

    const municipioId = await secretApiAxios
      .get(`municipios?_q=${encodeURIComponent(municipio)}&filters[uf][$eq]=${encodeURIComponent(uf)}`)
      .then(data => data.data?.data?.[0]?.id)
      .catch(err => {
        console.log({error: err.response.data})
        return false
      });

    return await secretApiAxios
      .get(`concessionarias?filters[municipios][id][$eq]=${municipioId}`)
      .then(data => data.data?.data?.[0])
      .catch(err => {
        console.log({error: err.response.data})
        return false
      });
  }

}